var exports = {
  "kL": "StickerPreview.module__container___cEJVME",
  "DD": "StickerPreview.module__title___cEJVME",
  "i1": "StickerPreview.module__previewContainer___cEJVME",
  "kH": "StickerPreview.module__previewItem___cEJVME",
  "u_": "StickerPreview.module__previewBox___cEJVME",
  "lc": "StickerPreview.module__darkBackground___cEJVME",
  "x7": "StickerPreview.module__lightBackground___cEJVME",
  "oz": "StickerPreview.module__previewImage___cEJVME",
  "Pf": "StickerPreview.module__label___cEJVME",
};

module.exports = exports;
